export enum FilterMutationTypes {
    SET_DATA = 'SET_DATA',
    SET_SORT = 'SET_SORT',
    CHANGE_PARAMETER = 'CHANGE_PARAMETER',
    CHANGE_SLIDE_VALUE = 'CHANGE_SLIDE_VALUE',
    CLEAR_CHECKS = 'CLEAR_CHECKS',
    CLEAR_SLIDES = 'CLEAR_SLIDES'
}